import { cmtsRouteManifest } from "./cmtsRouteManifest.js";
import type { CmtsRouteDefinition } from "./cmtsRouteTypes.js";

function normalizePath(path: string): string {
  return path.split("?")[0] || path;
}

export function findCmtsRouteByPath(path: string | undefined): CmtsRouteDefinition | undefined {
  const normalized = normalizePath(path ?? "");
  return cmtsRouteManifest.find((route) => route.path === normalized);
}

export function isCmtsCanonicalRoutePath(path: string | undefined): boolean {
  return Boolean(findCmtsRouteByPath(path));
}

export function getCmtsRoutePermission(path: string | undefined): string | undefined {
  return findCmtsRouteByPath(path)?.permission;
}

export function getCmtsRoutableManifestEntries(): readonly CmtsRouteDefinition[] {
  return cmtsRouteManifest.filter((route) => Boolean(route.componentExport));
}

export function getCmtsMenuManifestEntries(): readonly CmtsRouteDefinition[] {
  return cmtsRouteManifest.filter((route) => route.showInMenu).slice().sort((a, b) => (a.menuOrder ?? 9999) - (b.menuOrder ?? 9999));
}
